import React from 'react';
import { Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const SharedChart: React.FC = () => {
  const { shareCode } = useParams<{ shareCode: string }>();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        साझा चार्ट / Shared Chart
      </Typography>
      <Typography variant="body1">
        Share Code: {shareCode}
      </Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>
        Shared chart display coming soon...
      </Typography>
    </Container>
  );
};

export default SharedChart;